import {Component} from '@angular/core';
import {Observable} from 'rxjs'
import {select, Store} from '@ngrx/store'
import {numerSzkodySelector} from '../store/samoobsluga/samoobsluga.selectors';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss']
})
export class ErrorComponent {

  numerSzkody$: Observable<string>

  constructor(private store: Store) {
    this.numerSzkody$ = this.store.pipe(select(numerSzkodySelector))
  }

}
